
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.3050',
  depVersions: {
  "customer-portal-app": "static-1.3050",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.496",
  "data-fetching-client": "static-1.9925",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.455",
  "growth-payments-core": "static-1.26121",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5864",
  "hs-test-utils": "static-1.8297",
  "hub-http": "static-1.6480",
  "hub-http-shared-msw-handlers": "static-1.10565",
  "hubspot-dlb": "static-2.1882",
  "hubspot-prosemirror": "static-1.18916",
  "hubspot-url-utils": "static-1.4297",
  "HubStyleTokens": "static-2.11754",
  "I18n": "static-7.1667",
  "immutable": "static-2.83",
  "jasmine-runner": "static-1.6720",
  "payment-link-components": "static-1.24114",
  "portals-platform-bend-plugin": "static-1.22",
  "prosemirror": "static-1.13",
  "quartz": "static-1.7412",
  "quartz-core": "static-1.6631",
  "quartz-i18n": "static-1.1087",
  "react": "static-7.192",
  "react-colorpicker": "static-2.10475",
  "react-dlb": "static-1.88",
  "react-utils": "static-2.5534",
  "reselect": "static-3.9",
  "rich-text-lib": "static-1.20264",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.18341",
  "ui-components-test-utils": "static-1.5891",
  "UIComponents": "static-3.8700",
  "foundations-assets": "static-1.5149",
  "foundations-components": "static-1.8436",
  "foundations-theming": "static-1.4737",
  "foundations-theming-specialty": "static-1.2453",
  "framer-motion": "static-1.76",
  "metrics-js": "static-1.9867",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.1386",
  "quartz-config": "static-1.1190",
  "quartz-routing": "static-1.842",
  "quick-fetch": "static-1.4109",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1-fkhalid-delete-fcp-cls-subscribers.4",
  "rpc-client-utils": "static-1.4932",
  "sanitize-text": "static-1.8420",
  "styled-components": "static-2.95",
  "tanstack-table": "static-1.59",
  "ui-addon-draggable": "static-3.5025",
  "ui-addon-react-router-dom": "static-1.9805",
  "usage-tracker": "static-1.7623",
  "usage-tracker-anonymous": "static-1.6040",
  "usage-tracker-core": "static-1.7473",
  "video-components-external": "static-1.12099",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.75",
  "redux": "static-4.76",
  "bend-plugin-trellis-migration": "static-1.3596",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3689",
  "quartz-webpack": "static-1.3636",
  "bend-plugin-quartz-routing": "static-1.490",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.86",
  "customer-data-objects": "static-1.7955",
  "frontend-preferences-client": "static-1.8191",
  "laboratory-lib": "static-3.7420",
  "onboarding-scopes": "static-1.6720",
  "seat-types-lib": "static-1.664",
  "ui-addon-opt": "static-4.8631",
  "HeadJS": "static-2.793",
  "hs-test-utils-bend-plugin": "static-1.3408",
  "msw": "static-1.39",
  "testing-library": "static-1.156",
  "hs-locale-management": "static-1.270",
  "ts-schema": "static-1.4271",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.8158",
  "content-media-capture": "static-1.5372",
  "cssUtils": "static-1.887",
  "customer-data-ui-utilities": "static-1.10097",
  "file-manager-components": "static-1.24417",
  "HubStyle": "static-2.12061",
  "knowledge-content-types": "static-1.8634",
  "PatternValidationJS": "static-1.3162",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.499",
  "ui-addon-emoji-picker": "static-1.10154",
  "ui-addon-i18n": "static-1.11414",
  "ui-business-units-lib": "static-1.9354",
  "ui-shepherd-react": "static-3.10535",
  "video-data-lib": "static-1.35757",
  "i18n-data": "static-1.229",
  "moment-timezone": "static-5.88",
  "jasmine": "static-4.4581",
  "commerce-tours-lib": "static-1.6568",
  "customer-data-properties": "static-1.52495",
  "getting-started-shared-tasks": "static-1.19173",
  "growth-onboarding-reliability": "static-1.5348",
  "onboarding-tours": "static-1.17071",
  "reference-resolvers-lite": "static-1.8371",
  "sales-checkout-service-client": "static-1.3797",
  "ui-addon-iframeable": "static-1.9344",
  "user-context": "static-1.5384",
  "bender-build-tools": "static-1.3411",
  "dispatcher": "static-1.142",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.873",
  "hubspotter-http": "static-1.4842",
  "icons": "static-2.677",
  "mobile-manifest-mixins": "static-1.573",
  "module-federation": "static-1.30",
  "opentelemetry-fe": "static-1.411",
  "quartz-auth": "static-1.1087",
  "quartz-head": "static-1.1077",
  "quartz-test": "static-1.1087",
  "quartz-tracking": "static-1.791",
  "trellis-components": "static-1.2565",
  "ui-fonts": "static-1.1016",
  "usage-tracker-container": "static-1.7613",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9694",
  "data-token-picker": "static-1.16844",
  "FileManagerLib": "static-1.40057",
  "property-translator": "static-1.5665",
  "atom": "static-1.5353",
  "merchandise-lib": "static-1.276",
  "purchase-motions-components": "static-1.6308",
  "salesImages": "static-1.532",
  "SharedI18nStrings": "static-1.182",
  "foundations-components-test-utils": "static-1.5919",
  "react-create-root-preference": "static-1.66",
  "react-select-plus": "static-1.109",
  "react-virtualized": "static-2.104",
  "ui-images": "static-2.1238",
  "bend-plugin-foundations-components": "static-1.4705",
  "floating-ui": "static-1.62",
  "react-aria": "static-1.70",
  "trellis-assets": "static-1.2546",
  "bend-plugin-foundations-theming": "static-1.3220",
  "foundations-theming-base": "static-1.3722",
  "stylex": "static-1.38",
  "interframe": "static-3.5023",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.6037",
  "opentelemetry-fe-types": "static-1.36",
  "web-vitals": "static-1.12",
  "bend-plugin-chirp-manifest": "static-1.342",
  "chirp-fetch": "static-1.2162",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4741",
  "react-flip-move": "static-1.75",
  "apollo-link-hub-http": "static-2.4923",
  "content-media-composition-data-lib": "static-1.13176",
  "content-media-compositions": "static-2.17183",
  "idb-keyval": "static-1.48",
  "immer": "static-1.94",
  "immerable": "static-1.4419",
  "magpie-lib": "static-1.5733",
  "magpie-types": "static-1.5193",
  "media-bridge-lib": "static-1.19364",
  "inbound-db-properties-service-client": "static-1.4034",
  "superstore": "static-1.5025",
  "feedback-loader": "static-1.29766",
  "ai-components-ui-library": "static-1.9649",
  "ui-addon-video-player": "static-1.8969",
  "ui-coaching-tips": "static-1.29255",
  "ContentUtils": "static-1.69070",
  "fix-webm-duration": "static-1.27",
  "notification-sounds": "static-1.4692",
  "sassPrefix": "static-1.163",
  "react-dnd-compat": "static-1.4884",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "breeze-engine-lib": "static-1.1634",
  "copilot-toolkit": "static-1.11794",
  "avatar-components": "static-1.2761",
  "navigation-messaging": "static-1.8088",
  "redux-thunk": "static-2.77",
  "reference-resolvers": "static-1.8450",
  "commerce-products-lib": "static-1.10466",
  "crm-message-bus": "static-1.43695",
  "growth-data-modal": "static-1.5851",
  "hubspot-apollo-client": "static-1.5146",
  "onboarding-tours-client": "static-1.5285",
  "batch-promise": "static-1.1810",
  "calling-global-api": "static-1.65484",
  "calling-internal-common": "static-1.31585",
  "calling-lifecycle-internal": "static-1.66866",
  "calling-lifecycle-messages": "static-1.59160",
  "conditional-properties-service-client": "static-1.3989",
  "crm-index-visualization-core": "static-1.4500",
  "crm-links": "static-1.6596",
  "crm-pipelines-api-client-types": "static-1.4325",
  "customer-data-objects-ui-components": "static-1.13298",
  "customer-data-properties-shared-msw-handlers": "static-1.9892",
  "customer-data-property-utils": "static-1.8369",
  "external-options-client-types": "static-1.4317",
  "formula-editor": "static-1.14704",
  "framework-data-schema-resolvers": "static-1.7159",
  "google-libphonenumber": "static-1.42",
  "hs-resources": "static-1.458",
  "inbound-db-meta-service-client": "static-1.3718",
  "inbounddb-objects-service-types": "static-1.4403",
  "meetings-icalendar-utils-lib": "static-1.903",
  "multi-currency-client-types": "static-1.3886",
  "object-builder-ui-client": "static-1.49602",
  "pipeline-validation-client-types": "static-1.4160",
  "property-value-citations": "static-1.3109",
  "pulse": "static-1.896",
  "smart-data-capture-core": "static-1.74",
  "smart-property-lib": "static-1.8228",
  "tiered-pricing": "static-1.1907",
  "topics-actions-lib": "static-1.431",
  "trial-components-library": "static-1.14059",
  "ui-addon-form-validation": "static-1.11250",
  "zustand": "static-1.79",
  "growth-onboarding-confetti": "static-1.3330",
  "growth-onboarding-next-action-utils": "static-1.2639",
  "navigation-components": "static-1.18761",
  "onboarding-tours-utils": "static-1.1137",
  "ui-shepherd-tracker": "static-1.7916",
  "ui-universal-auth": "static-1.9342",
  "getting-started-shared-tasks-store": "static-1.18291",
  "opentelemetry-web": "static-1.11",
  "hubspotter-http-shared-msw-handlers": "static-1.10563",
  "usage-tracker-session-replay": "static-1.5309",
  "base-ui": "static-1.19",
  "react-day-picker": "static-1.7",
  "trellis-theming": "static-1.1236",
  "tanstack-virtual": "static-1.36",
  "audio-components": "static-1.6300",
  "FileManagerCore": "static-1.39916",
  "FileManagerImages": "static-1.37568",
  "video-components": "static-1.14101",
  "foundations-components-legacy": "static-1.1461",
  "purchase-motions-api": "static-1.6311",
  "signup-constants": "static-1.19552",
  "signup-ui-url-generator": "static-2.8330",
  "usage-tracker-public": "static-1.7434",
  "reactive-lib": "static-1.987",
  "simple-logging-lib": "static-1.3318",
  "chatspot-core": "static-1.22778",
  "growth-onboarding-feedback-components": "static-1.6851",
  "cms-field-types": "static-1.5081",
  "content-icons-ui": "static-1.2331",
  "integrations-lib": "static-1.16975",
  "underscore": "static-1.8",
  "breeze-engine-chat-components": "static-1.612",
  "breeze-engine-core": "static-1.912",
  "ably": "static-2.2",
  "highlight.js": "static-1.83",
  "markdown-it": "static-1.6",
  "commerce-permissions": "static-1.1044",
  "customer-data-tracking": "static-1.7148",
  "products-iframe-lib": "static-1.8536",
  "products-ui-components-shared-msw-handlers": "static-1.10947",
  "restore-request-side-panel-lib": "static-1.1609",
  "onboarding-data-sync-lib": "static-1.2448",
  "hubspot-apollo-cache": "static-1.605",
  "calling-error-reporting": "static-1.31592",
  "shared-worker-versioning": "static-1.11307",
  "calling-usage-tracker": "static-1.6804",
  "voice-sms-access-library": "static-1.1964",
  "conversations-skeleton-state": "static-1.7513",
  "crm-index-associations-lib": "static-1.6708",
  "framework-data-schema-quick-fetch": "static-1.7064",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10648",
  "redux-toolkit": "static-1.75",
  "sales-views-client-types": "static-1.4523",
  "location-customization-utils-lib": "static-1.10038",
  "bark-lib": "static-1.16780",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.99",
  "crm-properties-common-lib": "static-1.6156",
  "react-codemirror": "static-1.10907",
  "fdsr-migration-layer": "static-1.278",
  "framework-builder-read-service-client": "static-1.4199",
  "persist-promise": "static-1.3967",
  "event-emitter": "static-1.1220",
  "bend-plugin-pulse": "static-1.399",
  "fast-json-patch": "static-1.67",
  "data-agent-kit": "static-1.602",
  "fsm": "static-1.4012",
  "policy-lib": "static-1.7065",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10711",
  "embedded-academy-lib": "static-1.15439",
  "hubs-service-types": "static-1.1524",
  "growth-onboarding-next-action-components": "static-1.2667",
  "user-context-client": "static-1.4777",
  "nest": "static-1.503",
  "unified-auth-core-lib": "static-1.1138",
  "amplitude-session-replay-browser": "static-1.60",
  "breeze-artifacts-sdk": "static-1.249",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.58",
  "urlinator": "static-1.4800",
  "video-embed": "static-1.36591",
  "social-insights-client-types": "static-1.22685",
  "flux-actions": "static-1.364",
  "integrations-error-boundary-lib": "static-1.14390",
  "integrations-tracking-lib": "static-1.5875",
  "native-integrations-shared-strings": "static-1.8046",
  "redux-observable": "static-1.72",
  "ReduxMessenger": "static-2.10637",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.856",
  "InboxConnectUtils": "static-4.15502",
  "meetings-connect-utils-lib": "static-1.7876",
  "calling-orchestration-schema": "static-1.36741",
  "crm-record-cards-service-types": "static-1.3762",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16309",
  "browser-eslint": "static-2.57",
  "highcharts": "static-8.108",
  "trellis-story-utils": "static-1.4775",
  "storybook-react": "static-1.37",
  "academy-common-lib": "static-1.14899",
  "outpost": "static-1.4425",
  "universal-page-editor-lib": "static-1.3275",
  "adobe-sign-auth-lib": "static-1.405",
  "ads-unified-auth-lib": "static-1.1195",
  "google-sheets-integration-lib": "static-1.974",
  "microsoft-drive-auth-lib": "static-1.74",
  "surveymonkey-integration-lib": "static-1.419",
  "slack-ui-library": "static-1.10665",
  "hub-http-contrib": "static-1.3307",
  "ui-addon-sales-email": "static-1.5480",
  "academy-service-client": "static-1.3955",
  "croppie": "static-2.10",
  "final-form": "static-1.75",
  "SafeStorage": "static-1.4670",
  "trellis-ecosystem": "static-1.7587",
  "wootric-nps": "static-1.7177",
  "marketplace-ui-apps-core": "static-1.19189",
  "marketplace-ui-common": "static-1.20657",
  "developer-experience-shared-components": "static-1.10771",
  "immutable-less": "static-1.4918",
  "marketplace-ui-client-types": "static-1.18064",
  "ui-addon-integrations-directory-panel": "static-2.8291",
  "ui-extensibility-client-types": "static-1.4185",
  "ai-settings-ui-library": "static-1.8280",
  "nav-meta": "static-1.30398",
  "react-window": "static-1.13",
  "ui-product-approvals-common": "static-1.955",
  "apps-service-types": "static-1.4008",
  "oauth-service-types": "static-1.4507",
  "simple-data-table": "static-1.3479"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.3050",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.496",
  "data-fetching-client": "/data-fetching-client/static-1.9925",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.455",
  "growth-payments-core": "/growth-payments-core/static-1.26121",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5864",
  "hs-test-utils": "/hs-test-utils/static-1.8297",
  "hub-http": "/hub-http/static-1.6480",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10565",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18916",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "HubStyleTokens": "/HubStyleTokens/static-2.11754",
  "I18n": "/I18n/static-7.1667",
  "immutable": "/immutable/static-2.83",
  "jasmine-runner": "/jasmine-runner/static-1.6720",
  "payment-link-components": "/payment-link-components/static-1.24114",
  "portals-platform-bend-plugin": "/portals-platform-bend-plugin/static-1.22",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.7412",
  "quartz-core": "/quartz-core/static-1.6631",
  "quartz-i18n": "/quartz-i18n/static-1.1087",
  "react": "/react/static-7.192",
  "react-colorpicker": "/react-colorpicker/static-2.10475",
  "react-dlb": "/react-dlb/static-1.88",
  "react-utils": "/react-utils/static-2.5534",
  "reselect": "/reselect/static-3.9",
  "rich-text-lib": "/rich-text-lib/static-1.20264",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18341",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5891",
  "UIComponents": "/UIComponents/static-3.8700",
  "foundations-assets": "/foundations-assets/static-1.5149",
  "foundations-components": "/foundations-components/static-1.8436",
  "foundations-theming": "/foundations-theming/static-1.4737",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2453",
  "framer-motion": "/framer-motion/static-1.76",
  "metrics-js": "/metrics-js/static-1.9867",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.1386",
  "quartz-config": "/quartz-config/static-1.1190",
  "quartz-routing": "/quartz-routing/static-1.842",
  "quick-fetch": "/quick-fetch/static-1.4109",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1-fkhalid-delete-fcp-cls-subscribers.4",
  "rpc-client-utils": "/rpc-client-utils/static-1.4932",
  "sanitize-text": "/sanitize-text/static-1.8420",
  "styled-components": "/styled-components/static-2.95",
  "tanstack-table": "/tanstack-table/static-1.59",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5025",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9805",
  "usage-tracker": "/usage-tracker/static-1.7623",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6040",
  "usage-tracker-core": "/usage-tracker-core/static-1.7473",
  "video-components-external": "/video-components-external/static-1.12099",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.75",
  "redux": "/redux/static-4.76",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3596",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3689",
  "quartz-webpack": "/quartz-webpack/static-1.3636",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.490",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.86",
  "customer-data-objects": "/customer-data-objects/static-1.7955",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8191",
  "laboratory-lib": "/laboratory-lib/static-3.7420",
  "onboarding-scopes": "/onboarding-scopes/static-1.6720",
  "seat-types-lib": "/seat-types-lib/static-1.664",
  "ui-addon-opt": "/ui-addon-opt/static-4.8631",
  "HeadJS": "/HeadJS/static-2.793",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3408",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.156",
  "hs-locale-management": "/hs-locale-management/static-1.270",
  "ts-schema": "/ts-schema/static-1.4271",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.8158",
  "content-media-capture": "/content-media-capture/static-1.5372",
  "cssUtils": "/cssUtils/static-1.887",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10097",
  "file-manager-components": "/file-manager-components/static-1.24417",
  "HubStyle": "/HubStyle/static-2.12061",
  "knowledge-content-types": "/knowledge-content-types/static-1.8634",
  "PatternValidationJS": "/PatternValidationJS/static-1.3162",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.499",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10154",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11414",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9354",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10535",
  "video-data-lib": "/video-data-lib/static-1.35757",
  "i18n-data": "/i18n-data/static-1.229",
  "moment-timezone": "/moment-timezone/static-5.88",
  "jasmine": "/jasmine/static-4.4581",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6568",
  "customer-data-properties": "/customer-data-properties/static-1.52495",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19173",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5348",
  "onboarding-tours": "/onboarding-tours/static-1.17071",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8371",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3797",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9344",
  "user-context": "/user-context/static-1.5384",
  "bender-build-tools": "/bender-build-tools/static-1.3411",
  "dispatcher": "/dispatcher/static-1.142",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.873",
  "hubspotter-http": "/hubspotter-http/static-1.4842",
  "icons": "/icons/static-2.677",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.573",
  "module-federation": "/module-federation/static-1.30",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.411",
  "quartz-auth": "/quartz-auth/static-1.1087",
  "quartz-head": "/quartz-head/static-1.1077",
  "quartz-test": "/quartz-test/static-1.1087",
  "quartz-tracking": "/quartz-tracking/static-1.791",
  "trellis-components": "/trellis-components/static-1.2565",
  "ui-fonts": "/ui-fonts/static-1.1016",
  "usage-tracker-container": "/usage-tracker-container/static-1.7613",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9694",
  "data-token-picker": "/data-token-picker/static-1.16844",
  "FileManagerLib": "/FileManagerLib/static-1.40057",
  "property-translator": "/property-translator/static-1.5665",
  "atom": "/atom/static-1.5353",
  "merchandise-lib": "/merchandise-lib/static-1.276",
  "purchase-motions-components": "/purchase-motions-components/static-1.6308",
  "salesImages": "/salesImages/static-1.532",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5919",
  "react-create-root-preference": "/react-create-root-preference/static-1.66",
  "react-select-plus": "/react-select-plus/static-1.109",
  "react-virtualized": "/react-virtualized/static-2.104",
  "ui-images": "/ui-images/static-2.1238",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4705",
  "floating-ui": "/floating-ui/static-1.62",
  "react-aria": "/react-aria/static-1.70",
  "trellis-assets": "/trellis-assets/static-1.2546",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3220",
  "foundations-theming-base": "/foundations-theming-base/static-1.3722",
  "stylex": "/stylex/static-1.38",
  "interframe": "/interframe/static-3.5023",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6037",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.36",
  "web-vitals": "/web-vitals/static-1.12",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.342",
  "chirp-fetch": "/chirp-fetch/static-1.2162",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4741",
  "react-flip-move": "/react-flip-move/static-1.75",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4923",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13176",
  "content-media-compositions": "/content-media-compositions/static-2.17183",
  "idb-keyval": "/idb-keyval/static-1.48",
  "immer": "/immer/static-1.94",
  "immerable": "/immerable/static-1.4419",
  "magpie-lib": "/magpie-lib/static-1.5733",
  "magpie-types": "/magpie-types/static-1.5193",
  "media-bridge-lib": "/media-bridge-lib/static-1.19364",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4034",
  "superstore": "/superstore/static-1.5025",
  "feedback-loader": "/feedback-loader/static-1.29766",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9649",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8969",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29255",
  "ContentUtils": "/ContentUtils/static-1.69070",
  "fix-webm-duration": "/fix-webm-duration/static-1.27",
  "notification-sounds": "/notification-sounds/static-1.4692",
  "sassPrefix": "/sassPrefix/static-1.163",
  "react-dnd-compat": "/react-dnd-compat/static-1.4884",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1634",
  "copilot-toolkit": "/copilot-toolkit/static-1.11794",
  "avatar-components": "/avatar-components/static-1.2761",
  "navigation-messaging": "/navigation-messaging/static-1.8088",
  "redux-thunk": "/redux-thunk/static-2.77",
  "reference-resolvers": "/reference-resolvers/static-1.8450",
  "commerce-products-lib": "/commerce-products-lib/static-1.10466",
  "crm-message-bus": "/crm-message-bus/static-1.43695",
  "growth-data-modal": "/growth-data-modal/static-1.5851",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5146",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5285",
  "batch-promise": "/batch-promise/static-1.1810",
  "calling-global-api": "/calling-global-api/static-1.65484",
  "calling-internal-common": "/calling-internal-common/static-1.31585",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66866",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59160",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3989",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4500",
  "crm-links": "/crm-links/static-1.6596",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4325",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13298",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9892",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8369",
  "external-options-client-types": "/external-options-client-types/static-1.4317",
  "formula-editor": "/formula-editor/static-1.14704",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7159",
  "google-libphonenumber": "/google-libphonenumber/static-1.42",
  "hs-resources": "/hs-resources/static-1.458",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4403",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.903",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3886",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49602",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4160",
  "property-value-citations": "/property-value-citations/static-1.3109",
  "pulse": "/pulse/static-1.896",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.74",
  "smart-property-lib": "/smart-property-lib/static-1.8228",
  "tiered-pricing": "/tiered-pricing/static-1.1907",
  "topics-actions-lib": "/topics-actions-lib/static-1.431",
  "trial-components-library": "/trial-components-library/static-1.14059",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11250",
  "zustand": "/zustand/static-1.79",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3330",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2639",
  "navigation-components": "/navigation-components/static-1.18761",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1137",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7916",
  "ui-universal-auth": "/ui-universal-auth/static-1.9342",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18291",
  "opentelemetry-web": "/opentelemetry-web/static-1.11",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10563",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5309",
  "base-ui": "/base-ui/static-1.19",
  "react-day-picker": "/react-day-picker/static-1.7",
  "trellis-theming": "/trellis-theming/static-1.1236",
  "tanstack-virtual": "/tanstack-virtual/static-1.36",
  "audio-components": "/audio-components/static-1.6300",
  "FileManagerCore": "/FileManagerCore/static-1.39916",
  "FileManagerImages": "/FileManagerImages/static-1.37568",
  "video-components": "/video-components/static-1.14101",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1461",
  "purchase-motions-api": "/purchase-motions-api/static-1.6311",
  "signup-constants": "/signup-constants/static-1.19552",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8330",
  "usage-tracker-public": "/usage-tracker-public/static-1.7434",
  "reactive-lib": "/reactive-lib/static-1.987",
  "simple-logging-lib": "/simple-logging-lib/static-1.3318",
  "chatspot-core": "/chatspot-core/static-1.22778",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6851",
  "cms-field-types": "/cms-field-types/static-1.5081",
  "content-icons-ui": "/content-icons-ui/static-1.2331",
  "integrations-lib": "/integrations-lib/static-1.16975",
  "underscore": "/underscore/static-1.8",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.612",
  "breeze-engine-core": "/breeze-engine-core/static-1.912",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.83",
  "markdown-it": "/markdown-it/static-1.6",
  "commerce-permissions": "/commerce-permissions/static-1.1044",
  "customer-data-tracking": "/customer-data-tracking/static-1.7148",
  "products-iframe-lib": "/products-iframe-lib/static-1.8536",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10947",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1609",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2448",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.605",
  "calling-error-reporting": "/calling-error-reporting/static-1.31592",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11307",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6804",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1964",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7513",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6708",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7064",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10648",
  "redux-toolkit": "/redux-toolkit/static-1.75",
  "sales-views-client-types": "/sales-views-client-types/static-1.4523",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10038",
  "bark-lib": "/bark-lib/static-1.16780",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.99",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6156",
  "react-codemirror": "/react-codemirror/static-1.10907",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.278",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4199",
  "persist-promise": "/persist-promise/static-1.3967",
  "event-emitter": "/event-emitter/static-1.1220",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.399",
  "fast-json-patch": "/fast-json-patch/static-1.67",
  "data-agent-kit": "/data-agent-kit/static-1.602",
  "fsm": "/fsm/static-1.4012",
  "policy-lib": "/policy-lib/static-1.7065",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10711",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15439",
  "hubs-service-types": "/hubs-service-types/static-1.1524",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2667",
  "user-context-client": "/user-context-client/static-1.4777",
  "nest": "/nest/static-1.503",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1138",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.249",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.58",
  "urlinator": "/urlinator/static-1.4800",
  "video-embed": "/video-embed/static-1.36591",
  "social-insights-client-types": "/social-insights-client-types/static-1.22685",
  "flux-actions": "/flux-actions/static-1.364",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14390",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5875",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8046",
  "redux-observable": "/redux-observable/static-1.72",
  "ReduxMessenger": "/ReduxMessenger/static-2.10637",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.856",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15502",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7876",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36741",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3762",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16309",
  "browser-eslint": "/browser-eslint/static-2.57",
  "highcharts": "/highcharts/static-8.108",
  "trellis-story-utils": "/trellis-story-utils/static-1.4775",
  "storybook-react": "/storybook-react/static-1.37",
  "academy-common-lib": "/academy-common-lib/static-1.14899",
  "outpost": "/outpost/static-1.4425",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3275",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.405",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1195",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.974",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.74",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.419",
  "slack-ui-library": "/slack-ui-library/static-1.10665",
  "hub-http-contrib": "/hub-http-contrib/static-1.3307",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5480",
  "academy-service-client": "/academy-service-client/static-1.3955",
  "croppie": "/croppie/static-2.10",
  "final-form": "/final-form/static-1.75",
  "SafeStorage": "/SafeStorage/static-1.4670",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7587",
  "wootric-nps": "/wootric-nps/static-1.7177",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19189",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20657",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10771",
  "immutable-less": "/immutable-less/static-1.4918",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18064",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8291",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4185",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8280",
  "nav-meta": "/nav-meta/static-1.30398",
  "react-window": "/react-window/static-1.13",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.955",
  "apps-service-types": "/apps-service-types/static-1.4008",
  "oauth-service-types": "/oauth-service-types/static-1.4507",
  "simple-data-table": "/simple-data-table/static-1.3479"
}
};
